<div id="jitsi-iframe"></div>
<div>
    <button class="invite-btn tse-btn-primary" (click)="handleInviteGuest()">
        <lucide-angular [img]="Link" strokeWidth="2" [size]="16"></lucide-angular>
        Invite
    </button>
</div>